import cn from "classnames";
import Field from "components/shared/field";
import { FileField } from "components/shared/form";
import { createRequestForUploadFile } from "helpers/form";
import { fixLineStyle, getClientRouteOptions, taskMarkerStyle } from "helpers/map";
import { requiredField } from "helpers/validators";
import React, { useState } from "react";
import { CircleMarker, Polyline } from "react-leaflet";
import { apply, uploadFile } from "sources/books/fixRouteBids";

export default function FixRouteBidBtn(props) {
    const [formData, setFormData] = useState({ text: "" });
    const [loading, setLoading] = useState(false);
    const submitForm = (e) => {
        e.preventDefault();
        if (!formData.text) {
            return;
        }
        setLoading(true);
        const { file, text } = formData;
        const applyReq = (fileIds = []) => {
            apply({
                text,
                bidId: Number(props.bidId),
                routeOptions: getClientRouteOptions(props.routeOptions || props.defaultRouteOptions),
                routerType: props.routerType,
                startGeozone: props.startGeozone,
                endGeozone: props.endGeozone,
                fileIds,
            }).then(() => {
                setLoading(false);
                props.cancelSelectRange();
            });
        };
        if (file) {
            const paramsRequest = createRequestForUploadFile("file", file);
            uploadFile(paramsRequest).then((result) => {
                if (result) {
                    applyReq([result.id]);
                } else {
                    setLoading(false);
                }
            });
        } else {
            applyReq();
        }
    };
    return (
        <>
            {props.routeToFix && <Polyline positions={props.routeToFix} {...fixLineStyle} />}
            {props.startGeozone && (
                <CircleMarker
                    key={`${!!props.routeToFix}_start`}
                    center={[...props.startGeozone.location.coordinates].reverse()}
                    {...taskMarkerStyle}
                />
            )}
            {props.endGeozone && (
                <CircleMarker
                    key={`${!!props.routeToFix}_end`}
                    center={[...props.endGeozone.location.coordinates].reverse()}
                    {...taskMarkerStyle}
                />
            )}
            <div className={cn("map-form", { loading })}>
                <div className="map-form__head">
                    <div className="flex-1">
                        {props.selectGeozoneMode === "start"
                            ? "Выберите начальную точку на маршруте"
                            : props.selectGeozoneMode === "end"
                              ? "Выберите конечную точку на маршруте"
                              : "Опишите с какой проблемой вы столкнулись"}
                    </div>
                    <div className="map-form__head--btn" onClick={props.cancelSelectRange}>
                        <div className="map-form__head--icon icon-uEA07-delite" />
                    </div>
                </div>
                {props.selectGeozoneMode === "form" && (
                    <form className="map-form__body" onSubmit={submitForm}>
                        <div className="form-group mt-2">
                            <label className="field-wrap__label--required">Описание ошибки</label>
                            <Field
                                inputProps={{ name: "text", className: "form-control form-control-sm" }}
                                value={formData.text}
                                required
                                validators={[requiredField]}
                                onChange={({ value }) => setFormData({ ...formData, text: value })}
                            />
                        </div>
                        <div>
                            <label>Файл</label>
                            <FileField
                                bWrapper="row"
                                inputProps={{ name: "file" }}
                                value={formData.file}
                                onChange={({ value }) => setFormData({ ...formData, file: value })}
                            />
                        </div>
                        <button type="submit" disabled={!formData.text} className="btn btn-sm btn-brand">
                            Сохранить
                        </button>
                    </form>
                )}
            </div>
        </>
    );
}
